function chooseShacketArm({ forced, preview, consent, storage, random, now }) {
  if (forced === 'A' || forced === 'B') return { arm: forced, measured: false, reason: 'preview' };
  if (preview || !consent) return { arm: 'A', measured: false, reason: preview ? 'preview' : 'consent' };
  const key = 'idv_shacket_fall_20261001';
  try {
    let saved;
    try { saved = JSON.parse(storage.getItem(key)); } catch (_) {}
    if (!saved || !['A', 'B'].includes(saved.arm) || !(saved.expires > now) || saved.expires > now + 31 * 86400000) {
      saved = { arm: random() < .5 ? 'A' : 'B', expires: now + 30 * 86400000 };
    }
    storage.setItem(key, JSON.stringify(saved));
    if (storage.getItem(key) !== JSON.stringify(saved)) throw new Error('Storage unavailable');
    return { ...saved, measured: true, reason: 'assigned' };
  } catch (_) { return { arm: 'A', measured: false, reason: 'storage' }; }
}

function initShacketFall(root) {
  'use strict';
  const section = root.querySelector('.iv-fall');
  const rail = section.querySelector('.iv-fall__rail');
  const cards = [...rail.querySelectorAll('[data-look]')];
  const filters = [...section.querySelectorAll('[data-filter]')];
  const previous = section.querySelector('[data-prev]');
  const next = section.querySelector('[data-next]');
  const counter = section.querySelector('.iv-fall__count');
  const dialog = root.querySelector('.iv-fall__dialog');
  let selected = null;
  let trigger = null;
  let savedOverflow = '';
  const visibleCards = () => cards.filter(card => !card.hidden);
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';

  function updateNavigation() {
    const available = visibleCards();
    const bounds = rail.getBoundingClientRect();
    const inView = available.filter(card => {
      const rect = card.getBoundingClientRect();
      return Math.min(rect.right, bounds.right) - Math.max(rect.left, bounds.left) > rect.width * .7;
    });
    const first = Math.max(0, available.indexOf(inView[0])) + 1;
    const last = Math.max(first, available.indexOf(inView.at(-1)) + 1);
    counter.textContent = `${first === last ? first : `${first}-${last}`} / ${available.length}`;
    previous.disabled = rail.scrollLeft < 2;
    next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 3;
  }

  function move(direction) {
    const available = visibleCards();
    const first = available[0];
    if (!first) return;
    const gap = parseFloat(getComputedStyle(rail).gap);
    const step = first.getBoundingClientRect().width + gap;
    const count = Math.max(1, Math.floor((rail.clientWidth + gap) / step));
    const current = Math.round(rail.scrollLeft / step);
    rail.scrollTo({ left: Math.max(0, current + direction * count) * step, behavior: motion() });
  }

  filters.forEach(button => button.addEventListener('click', () => {
    const choice = button.dataset.filter;
    filters.forEach(filter => filter.setAttribute('aria-pressed', String(filter === button)));
    cards.forEach(card => { card.hidden = choice !== 'all' && card.dataset.category !== choice; });
    rail.scrollTo({ left: 0, behavior: 'instant' });
    updateNavigation();
  }));
  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  rail.addEventListener('keydown', event => {
    if (event.target !== rail) return;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      move(event.key === 'ArrowLeft' ? -1 : 1);
    }
    if (event.key === 'Home' || event.key === 'End') {
      event.preventDefault();
      rail.scrollTo({ left: event.key === 'Home' ? 0 : rail.scrollWidth, behavior: motion() });
    }
  });
  rail.addEventListener('scroll', updateNavigation, { passive: true });
  new ResizeObserver(updateNavigation).observe(rail);

  function showCard(card) {
    selected = card;
    const available = visibleCards();
    const index = available.indexOf(card);
    dialog.querySelector('[data-modal-label]').textContent = `${index + 1} / ${available.length}  ${card.getAttribute('aria-label')}`;
    const image = dialog.querySelector('[data-modal-image]');
    image.src = card.dataset.full;
    image.alt = card.querySelector('img').alt;
    dialog.querySelector('[data-modal-copy]').textContent = card.querySelector('.iv-fall__caption p').textContent;
    dialog.querySelector('[data-modal-prev]').disabled = index === 0;
    dialog.querySelector('[data-modal-next]').disabled = index === available.length - 1;
  }

  section.querySelectorAll('[data-open]').forEach(button => button.addEventListener('click', () => {
    trigger = button;
    showCard(button.closest('[data-look]'));
    savedOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
    dialog.querySelector('[data-close]').focus();
  }));
  function modalMove(direction) {
    const available = visibleCards();
    const card = available[available.indexOf(selected) + direction];
    if (card) showCard(card);
  }
  dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
  dialog.querySelector('[data-modal-prev]').addEventListener('click', () => modalMove(-1));
  dialog.querySelector('[data-modal-next]').addEventListener('click', () => modalMove(1));
  dialog.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      modalMove(event.key === 'ArrowLeft' ? -1 : 1);
    }
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.body.style.overflow = savedOverflow;
    trigger?.focus({ preventScroll: true });
  });
  updateNavigation();
}
(() => {
  'use strict';
  const host = document.querySelector('[data-idv-shacket-fall]');
  if (!host || host.dataset.bound) return;
  host.dataset.bound = 'true';
  const control = host.querySelector('[data-style-control]');
  const mount = host.querySelector('[data-style-mount]');
  const params = new URLSearchParams(location.search);
  const key = 'idv_shacket_fall_20261001';
  const experiment = 'shacket_fall_20261001';
  const privateKey = '__idv_shacket_fall_20261001__';
  const preview = host.dataset.preview === 'true' || params.has('preview_theme_id') || Boolean(window.Shopify?.designMode);
  let state, revoked = false, exposed = false, cartWritten = '', cartQueue = Promise.resolve();
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  function event(action, detail = {}) {
    if (!state?.measured || revoked || !allowed()) return;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    if (!window.idvShacketFallGaConfigured) {
      window.gtag('config', 'G-8HCMWVSWJM', { send_page_view: false });
      window.idvShacketFallGaConfigured = true;
    }
    window.gtag('event', 'idv_sf_' + action + '_' + state.arm.toLowerCase(), {
      send_to: 'G-8HCMWVSWJM', experiment_id: experiment, experiment_variant: state.arm,
      product_id: '8894748164258', ...detail
    });
  }
  // Only the experiment label is sent; no cart items, quantities or customer fields are changed.
  function markCart(clear = false) {
    if (!clear && (!state?.measured || revoked || !allowed())) return;
    const value = clear ? '' : state.arm + (exposed ? ':seen' : ':assigned');
    if (cartWritten === value) return;
    cartQueue = cartQueue.catch(() => {}).then(async () => {
      if (!clear && (revoked || !allowed())) return;
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { [privateKey]: value } })
      });
      if (!response.ok) throw new Error('Experiment label not saved');
      cartWritten = value;
      host.dataset.orderLabel = clear ? 'cleared' : 'saved';
    }).catch(() => { host.dataset.orderLabel = 'unverified'; });
  }
  function fallback(reason) {
    if (state?.measured) event('fallback', { failure_reason: reason });
    if (mount.querySelector('dialog[open]')) mount.querySelector('dialog').close();
    mount.hidden = true;
    control.hidden = false;
    host.dataset.status = 'fallback';
    host.dataset.displayed = 'A';
    // Keep original assignment for intention-to-treat analysis; flag failed presentations separately.
    if (state?.measured) host.dataset.failure = reason;
  }
  function start() {
    if (state) return;
    state = chooseShacketArm({
      forced: params.get('iv_style'), preview, consent: allowed(), now: Date.now(),
      storage: { getItem: name => localStorage.getItem(name), setItem: (name, value) => localStorage.setItem(name, value) },
      random: () => { const n = new Uint32Array(1); crypto.getRandomValues(n); return n[0] / 4294967296; }
    });
    host.dataset.arm = state.arm;
    host.dataset.measured = String(state.measured);
    host.dataset.status = state.reason;
    host.dataset.displayed = 'A';
    if (state.arm === 'B') {
      try {
        mount.append(host.querySelector('template[data-style-template]').content.cloneNode(true));
        mount.hidden = false;
        if (getComputedStyle(mount.querySelector('.iv-fall')).getPropertyValue('--iv-fall-ready').trim() !== '1') throw new Error('css');
        initShacketFall(mount);
        mount.querySelectorAll('.iv-fall__photo img').forEach(img => {
          img.addEventListener('error', () => fallback('image'), { once: true });
          if (img.complete && !img.naturalWidth) throw new Error('image');
        });
        control.hidden = true;
        host.dataset.displayed = 'B';
      } catch (_) { fallback('initialization'); }
    }
    event('assigned');
    markCart();
    const heading = host.querySelector(host.dataset.displayed === 'B' ? '.iv-fall__header' : '.iv-shacket-ugc__head');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (exposed || !entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .5)) return;
        exposed = true;
        host.dataset.exposed = 'true';
        event('view', { displayed_variant: host.dataset.displayed });
        markCart();
        observer.disconnect();
      }, { threshold: .5 });
      observer.observe(heading);
    }
    host.addEventListener('click', e => {
      const item = e.target.closest('[data-open],[data-filter],[data-next],[data-prev],[data-iv-ugc-index],[data-iv-ugc-more]');
      if (item) event('interact', { interaction: item.dataset.filter || item.dataset.open || item.getAttribute('aria-label') || 'more' });
    });
    document.addEventListener('ajaxProduct:added', () => {
      // This theme event has no product payload; classify it as a page-cart signal, not a purchase.
      event('page_cart');
      cartWritten = '';
      markCart();
    });
    mount.querySelector('.iv-fall__cta')?.addEventListener('click', e => {
      const input = document.querySelector('main input[type="radio"][name="Size"]');
      const target = input?.closest('fieldset') || document.querySelector('form[action*="/cart/add"]');
      if (!target) return;
      e.preventDefault();
      event('size');
      target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
      const focus = target.querySelector('input:checked') || target.querySelector('input:not(:disabled),select,button');
      focus?.focus({ preventScroll: true });
    });
  }
  document.addEventListener('visitorConsentCollected', () => {
    if (state?.measured && !allowed()) {
      revoked = true;
      try { localStorage.removeItem(key); } catch (_) {}
      markCart(true);
      host.dataset.measured = 'false';
    }
  });
  if (params.has('iv_style') || preview || window.Shopify?.customerPrivacy) start();
  else {
    const timeout = setTimeout(start, 1500);
    window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], () => { clearTimeout(timeout); start(); });
  }
})();
